import Model from "./abstract/Model";
import UserPreference from "./UserPreference";
import Client from "./Client";
import Role from "./Role";

export default class User extends Model {

  constructor(props) {
    super();

    this.initializeAttributes(props, {
      preference: UserPreference,
      client: Client,
      roles: (value) => Role.list(value)
    });
  }

  get role_name() {
    if (!this.roles);

    var name = ''

    this.roles.forEach(role => {
      if (name) name += ',';
      name += i18n.database.table.roles.name[role.type.toLowerCase()]
    });

    return name;
  }
}